module.exports = __webpack_public_path__ + "img/HNKL10.png";